import React from 'react'
import { useState } from 'react';

import {OfferCardJSX} from '../../../common/offerCard/offerCard';


import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Pagination } from '../../../common/pagination/uiPagination.js';

const SuggestedOfferJsx = (props) => {
  const {

    offerData,onPaginationButtonClick, page
  } = props;

  const itemsPerPage = 10

  const [currentPage] = useState(1);

  const currentItems = offerData?.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );

 
  return (
    <>
      <section className="alldashboard cust-offers">
        <div className="dashboardrightpanel">
          <div className="suggestedoffercustomer">
          <div className="dashboard-ps-offer">
            <section className="limitedoffer ">
              {
                currentItems &&
                <div className="limitedofferinner">
                
                  <div className="offerslider ">
                  
                      {
                        currentItems?.map(offer => {
                          return <div>
                               <OfferCardJSX
                          offerimgurl={offer?.imageUrl}
                          offerparentInstitutionCategory={offer?.parentInstitutionCategory}
                          offervalidTo={offer?.validTo}
                          offerofferName={offer?.offerName}
                          offerdescription={offer?.description}
                          offerexternalUrl={offer?.externalUrl}
                          isDescription={true}
                        /> 
                           
                          </div>
                        })
                      }
                 <section className="newpagination"> <Pagination
                        currentPage={currentPage}
                        page={page}
                        allOffersData={offerData}
                        currentItems={currentItems}
                        onPaginationButtonClick={onPaginationButtonClick}
                        itemsPerPage={itemsPerPage}
                      /></section>
                  </div>
                </div>
              }
            
            </section>
</div>
          </div>
        </div>
      </section>
    </>

  );
};

export default SuggestedOfferJsx;